import { photoUrl } from "../lib/api";

export const Lightbox = ({ entry, onClose }) =>
  entry ? (
    <div className="lb" onClick={onClose} data-testid="lightbox">
      <img src={photoUrl(entry.photoId)} alt={entry.name} />
      <p>{entry.name}{entry.lionName ? ` · «${entry.lionName}»` : ""}</p>
    </div>
  ) : null;
